import en from '../l10n/translations.en-US.json';

// Other supported langauges from ui-utils
// import de from '../l10n/translations.de.json';
// import es from '../l10n/translations.es.json';
// import fr from '../l10n/translations.fr.json';
// import ja from '../l10n/translations.ja.json';
// import pt from '../l10n/translations.pt.json';
// import zh from '../l10n/translations.zh.json';

const translations = { en };

export default translations;
